<div class="samples-container">
  @if (isLoading) {
    <div class="loader">
    </div>
  }
  @if (HasError) {
    <div class="error-placeholder">
      <h3>Erreur lors du chargement des données</h3>
    </div>
  }
  <div #embedContainer id="embedContainer"></div>
</div>